export default __webpack_public_path__ + "4b1117fa40078cc42eb25fe98a9fe642.png";